import React from "react";

import { GridItem, GridRow } from "commons/ui/Grid";
import Select from "commons/ui/input/Select";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { MaterialCategoryListHook } from "hooks/list/useMaterialCategoryList";

import { IndoorOrOutdoor } from "types/enums";

function MaterialCategoryExtraFilters({
    materialCategoryListHook,
}: {
    materialCategoryListHook: MaterialCategoryListHook;
}) {
    const { staticFilterHook } = materialCategoryListHook;
    const { setValue, form } = staticFilterHook;

    return (
        <GridRow>
            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Tipologia"}
                    options={[
                        { label: "Tutti", value: "" },
                        { label: "Indoor", value: IndoorOrOutdoor.indoor },
                        { label: "Outdoor", value: IndoorOrOutdoor.outdoor },
                    ]}
                    setValue={setValue}
                    value={form.type}
                    path={"type"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>
        </GridRow>
    );
}

function MaterialCategoryTableFilters({
    materialCategoryListHook,
}: {
    materialCategoryListHook: MaterialCategoryListHook;
}) {
    const { onSearchFilterChange, filterSearchHook, staticFilterHook } = materialCategoryListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;
    const { clearStaticFilters } = staticFilterHook;

    const clearAllFilters = React.useCallback(() => {
        clearFilters();
        clearStaticFilters();
    }, [clearFilters, clearStaticFilters]);

    return (
        <FiltersContainer
            applyFilters={applyFilters}
            clearFilters={clearAllFilters}
            extraFilters={
                <MaterialCategoryExtraFilters materialCategoryListHook={materialCategoryListHook} />
            }
            openDefault={staticFilterHook.filters.length > 0}
        >
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.name}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default MaterialCategoryTableFilters;
